import { TableHeader } from '@plato/ui-legacy/components/tables/table-header';
import { DataTable } from '@plato/ui/components/data-table';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../../utils/api.ts';
import { useProductAvailibilityColumns } from '../../list-views/columns/use-product-availibility-columns.tsx';

type Props = {
    erpProductId: string;
};

export function InventoryDetailsAvailability({ erpProductId }: Props) {
    const { t } = useTranslation();
    const availibilityColumns = useProductAvailibilityColumns();

    const { data: availibilityRawData, isLoading: isLoadingAvailibility } =
        api.platoUser.grid.getManyStorageStockLevels.get.useQuery({
            productVariantId: erpProductId,
        });

    const availibilityCount = availibilityRawData ? availibilityRawData.length : 0;

    const availibilityData = useMemo(
        () => (availibilityRawData ? availibilityRawData : []),
        [availibilityRawData],
    );

    return (
        <>
            <DataTable
                emptyLabel={t('empty_table__no_results')}
                isLoading={isLoadingAvailibility}
                data={availibilityData}
                columns={availibilityColumns}
            />
            <TableHeader count={availibilityCount} isLoadingCount={isLoadingAvailibility} />
        </>
    );
}
